// Stacking Builder page updates

const createRightSideOpener = (modal) => {
  const div = document.createElement("div");
  const button = document.createElement("button");
  
  button.textContent = "Your Stack Summary";

  button.addEventListener("click", function () {
    modal.classList.add("open");
    document.body.style.overflow = "hidden"; // Lock scrolling
  })

  div.classList.add("es-rb-header-wrapper");
  div.append(button);

  const createProgress = document.createElement("div");
  createProgress.classList.add('rb-progress-widget');
  createProgress.innerHTML = createProgressWidget();

  div.prepend(createProgress);

  return div;
}

const createRightSideCloser = (modal) => {
  const button = document.createElement('button');
  const svg = document.createElement('img');

  button.addEventListener("click", function () {
    modal.classList.remove("open");
    document.body.style.overflow = ""; // Unlock scrolling
  })

  svg.src = 'https://cdn.shopify.com/s/files/1/0756/3867/files/modal-close-icon.svg?v=1753290351';
  button.append(svg);
  button.classList.add("es-rb-header-closer");

  return button;
}

const rebuildProgressBar = (bar) => {
  const added = bar.dataset.rbAdded - 0;
  const left = bar.dataset.rbLeft - 0;
  bar.innerHTML = '';

  // console.log("Calling rebuildProgressBar():");

  for (let i = 0; i < added + left; i++) {
    const span = document.createElement('span');
    
    if (i < added) {
      span.classList.add('added');
    }

    bar.append(span);
  }
}

// const progressBar = (header, progressBarWrapper, badgeText) => {
//   console.log("progressBar => ", header);
//   // const progressBarWrapper = document.querySelector(".rb-incentives-status__container");
//   var eh = header.querySelector('.heading');
//   var ep = header.querySelector(".es--progress-bar");

//   if (ep) {
//     header.querySelector(".es--progress-bar").style.display = "none";
//   }

//   if (progressBarWrapper) {
//     const progressBar = progressBarWrapper?.querySelectorAll('.rb-progress-bar');
//     var badge = document.createElement('span');
//     var title;

//     if (eh) {
//       title = eh;
//     } else {
//       title = document.createElement("h2");
//       title.classList.add("heading");
//     }

//     badge.classList.add('badge');
//     badge.textContent = badgeText;

//     progressBar.forEach(bar => {
//       const updateTitleText = () => {
//         const itemCount = parseInt(bar.dataset.rbAdded) || 0;
//         let titleText = '';
//         let savingText = '10% OFF';
//         if (header.querySelector('input[name="purchaseOption"]:checked').value.indexOf("onetime") > -1) {
//           savingText = "10% OFF";
//         } else {
//           savingText = "20% OFF";
//         }
        
//         if (itemCount === 0) {
//           titleText = `Select 3 items to enjoy <span>10% OFF</span>`;
//         } else if (itemCount === 1) {
//           titleText = `Select 2 more items to enjoy <span>${savingText}</span>`;
//         } else if (itemCount === 2) {
//           titleText = `Select 1 more item to enjoy <span>${savingText}</span>`;
//         } else if (itemCount >= 3) {
//           titleText = `You have received <span>${savingText}</span>`;
//         }
        
//         title.innerHTML = titleText;
//       }
//       updateTitleText();
//       rebuildProgressBar(bar);

//       const config = { attributes: true };

//       const callback = function(mutationsList, observer) {
//         for(const mutation of mutationsList) {
//           if (mutation.type === 'childList') {
//             console.log('A child node has been added or removed.');
//           } else if (mutation.type === 'attributes') {        
//             rebuildProgressBar(bar);
//             updateTitleText();
//           }
//         }
//       };

//       const observer = new MutationObserver(callback);
//       observer.observe(bar, config);
//     });
      
//     progressBarWrapper.append(badge);
//     header.prepend(progressBarWrapper);

//     if (eh) {
//       title.style.order = "-1";
//     } else {
//       header.prepend(title);
//     }

//     progressBarWrapper.classList.add("es--progress-bar");
//     progressBarWrapper.style.display = "block";
//   }
// }

const createProgressWidget = () => {
  let spans = '';
  for (let i = 0; i < 3; i++) {
    spans += '<span class="rpb-item"></span>';
  }

  let div = `
    <h2 class="heading">Add 3 items for <span>10% OFF</span></h2>
    <div class="rb-progress-bar">
      <div class="rpb-wrapper">
        ${spans}
      </div>
      <span class="badge">-10%</span>
    </div>`;

  return div;
}

const updateProgressWidget = () => {
  const header = document.querySelector(".es-rb-header");
  const widget = header.querySelector('.rb-progress-widget');
  const rpbItems = widget.querySelectorAll('.rpb-item');

  const header_wrapper = document.querySelector(".es-rb-header-wrapper");
  let widget2 = null;
  let rpbItems2 = [];
  if (header_wrapper) {
    widget2 = header_wrapper.querySelector('.rb-progress-widget');
    rpbItems2 = widget2.querySelectorAll('.rpb-item');
  }

  var purchaseType = 1;
  var savingText = "";

  if (header.querySelector('input[name="purchaseOption"]:checked').value.indexOf("onetime") > -1) {
    purchaseType = 1;
  } else {
    purchaseType = 2;
  }

  if (purchaseType == 1) {
    widget.querySelector('.badge').textContent = "-10%";
    savingText = "10% OFF";

    if (widget2) {
      widget2.querySelector('.badge').textContent = "-10%";
    }

  } else {
    widget.querySelector('.badge').textContent = "-20%";
    savingText = "20% OFF";

    if (widget2) {
      widget2.querySelector('.badge').textContent = "-20%";
    }
  }

  const getTotalCartItems = () => {
    let total = 0;
    header.querySelectorAll('.rb-input').forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  };

  var itemCount = getTotalCartItems();
  if (itemCount == 3) {
    widget.querySelector('.heading').innerHTML = `Your Stack Is <span>${savingText}</span>`;
  } else {
    widget.querySelector('.heading').innerHTML = `Add ${3 - itemCount} items for <psan>${savingText}</span>`;
  }
  
  rpbItems.forEach((item, index) => {
    if (index < itemCount) {
      item.classList.add("added");
    } else {
      item.classList.remove('added');
    }
  });

  if (!widget2) {
    return;
  }
  rpbItems2.forEach((item, index) => {
    if (index < itemCount) {
      item.classList.add("added");
    } else {
      item.classList.remove('added');
    }
  });
}

const stackSummary = (widget, header) => {
  const div = document.createElement("div");
  const h2 = document.createElement("h2");
  const cartItems = document.createElement("div");

  h2.classList.add("stack-summary-heading-mobile");
  // h2.style.display = "none";
  h2.textContent = "Your Stack Summary";

  cartItems.classList.add("stack-summary-cart-items")

  div.classList.add('stack-summary-wrapper');
  div.append(h2);
  div.append(cartItems);

  header.prepend(div);
}
const cleanPrice = (priceStr) => {
  // Remove $ and any non-numeric characters except dot
  return parseFloat(priceStr.replace(/[^0-9.]/g, '')) || 0.00;
};
const subscriptionWidget = (header) => {
  const select = header.querySelector('.rb-subscribe-and-save-container');
  let discountedPercent = 0.2;
  const div = document.createElement("div");
  const rbPrice = header.querySelector('.rb-price');
  rbPrice.style.display = "none";
  const span = document.createElement("span");
  span.textContent = "•";
  span.style.display = "none";
  
  
  // const originalPrice = parseFloat(rbPrice.innerText.replace('$', ''));
  const originalPrice = cleanPrice(rbPrice.innerText);
  const discountedPrice = (originalPrice * 0.8).toFixed(2);
  const discountedPercent10 = (originalPrice * 0.9).toFixed(2)
  
  // console.log('subscriptionWidget calculation:', {
  //   originalPrice,
  //   discountedPrice,
  //   rawPrice: rbPrice.innerText
  // });

  const customSelect = `
      <div class="rc-template__radio">
        <label class="rc-radio rc-radio--active onetime-radio px-3 py-2" for="rc-radio1">
          <input id="rc-radio1" class="rc-radio__input m-0 mr-3" type="radio" name="purchaseOption" value="onetime" checked="checked">
          <span class="rc-radio__label">
            <span class="text">One-time purchase</span>
            <span class="price-wrapper">
              $${discountedPercent10}
              <span class="tstrike">${rbPrice.innerText.replace(/^US\$/, '$')}</span>
            </span>
          </span>
        </label>
        <label class="rc-radio subscription-radio px-3 py-2" for="rc-radio2">
          <input id="rc-radio2" class="rc-radio__input m-0 mr-3" type="radio" name="purchaseOption" value="subscription">
          <span class="rc-radio__label">
            <span class="text rc-radio__subscription">Subscribe & Save</span>
            <span class="price-wrapper">
              $${discountedPrice}
              <span class="tstrike">${rbPrice.innerText.replace(/^US\$/, '$')}</span>
            </span>
          </span>
          <span class="percent-label">Extra  20% off</span>
        </label>
        <div class="rc-select"></div>
        <ul>
          <li>You save an extra 20% off.</li>
          <li>No commitment. Cancel anytime.</li>
          <li>Free USA shipping</li>
        </ul>
      </div>
    `;

  div.innerHTML = customSelect;
  div.classList.add("subscripton-widget");
  div.querySelector('.rc-select').append(select);

  div.querySelectorAll('input[name="purchaseOption"]')?.forEach(input => {
    input.addEventListener("change", function () {
      this.closest(".rc-template__radio").querySelectorAll(".rc-radio")?.forEach(label => {
        label.classList.remove("rc-radio--active");
      });
      this.closest(".rc-radio").classList.add('rc-radio--active');

      header.querySelector(".rc-select input[type='checkbox']").click();
      
      updateProgressWidget();

      // if (input.value.indexOf("onetime") > -1) {
      //   document.querySelector(".rb-bundle-description-percent").textContent = "10%";
      // } else {
      //   document.querySelector(".rb-bundle-description-percent").textContent = "20%";
      // }

      setTimeout(() => {
        updateAddToStackButton(document.querySelector("#recharge-bundles"));
      }, 0);
    });
  });

  header.querySelector(".rb-btn-wrapper").prepend(div);
  header.querySelector(".rb-btn-wrapper .rb-btn").textContent = "Add Stack To Cart";
  header.querySelector(".rb-btn-wrapper .rb-btn").append(span);
  header.querySelector(".rb-btn-wrapper .rb-btn").append(rbPrice);
}

const createRightSide = (widget) => {
  const div = document.createElement('div');
  const createProgress = document.createElement("div");

  div.classList.add('es-rb-header');
  div.append(widget.querySelector('.rb-header'));
  div.append(widget.querySelector('.rb-sticky-form'));

  createProgress.classList.add('rb-progress-widget');
  createProgress.innerHTML = createProgressWidget();

  subscriptionWidget(div);
  stackSummary(widget, div);
  // progressBar(div, document.querySelector(".rb-incentives-status__container"), "-10%");
  div.prepend(createProgress);

  const h2 = document.createElement("h2");
  h2.classList.add("stack-summary-heading");
  h2.textContent = "Your Stack Summary";
  div.prepend(h2);

  if (window.innerWidth < 990) {
    div.append(createRightSideCloser(div));
    widget.querySelector("#build-a-box > div:first-child")?.prepend(createRightSideOpener(div));
  }

  widget.querySelector("#build-a-box > div:first-child")?.prepend(div);

  const keep_button = document.createElement("button");
  keep_button.classList.add("keep-building-button");
  keep_button.textContent = "Keep Building Your Stack";
  keep_button.addEventListener("click", function () {
    div.classList.remove("open");
    document.body.style.overflow = ""; // Unlock scrolling
  });
  div.append(keep_button);
}

const stackSummaryCartItems = (header, widget) => {
  const items = header.querySelectorAll(".rb-item");

  // count total items in cart
  const getTotalCartItems = () => {
    let total = 0;
    header.querySelectorAll('.rb-input').forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  };

  // update plus buttons in cart
  const updateCartPlusButtons = () => {
    const totalItems = getTotalCartItems();
    // console.log("totalItems => ", totalItems);
    header.querySelectorAll('.rb-btn-qty-plus').forEach(button => {
      // console.log("Updating button for item: ", button);
      button.disabled = totalItems >= 3;
      if ( !button.disabled ) {
        button.classList.remove('tdisabled');
      }
    });
  };

  items?.forEach(item => {
    item.querySelector(".rb-btn-qty-plus").addEventListener("click", function () {
      const button = widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"] .rb-btn-qty-plus`);
      button.click();
      button.disabled = true;
      button.classList.remove('tdisabled');
      setTimeout(() => {
        button.disabled = false;
      }, 300);
      setTimeout(() => {
        item.querySelector('input').value = widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"] input`).value;
        if (widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"] input`).value == 0) {
          item.remove();
          widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"]`).classList.add("no-added");
        }
        updateCartPlusButtons();
        updateProgressWidget();
      }, 100);
    });

    
    item.querySelector(".rb-btn-qty-minus").addEventListener("click", function () {
      const button = widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"] .rb-btn-qty-minus`);

      button.click();
      button.disabled = true;
      button.classList.remove('tdisabled');
      setTimeout(() => {
        button.disabled = false;
      }, 300);

      setTimeout(() => {
        item.querySelector('input').value = widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"] input`).value;

//        setTimeout(() => {
          if (widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"] input`).value == 0) {
            item.remove();
            widget.querySelector(`.rb-box-builder div[data-rb-item-id="${item.dataset.rbItemId}"] input`).closest('.rb-qty-wrapper').classList.add('no-added');
          }
          updateCartPlusButtons();
          updateProgressWidget();
        //}, 200);
      }, 100);
    });
  })
// Initial button state update
  updateCartPlusButtons();
  updateProgressWidget();
}

const makeDiscountWidget = (rbPrice) => {
  const originalPrice = cleanPrice(rbPrice.innerText);
  const discountedPrice = (originalPrice * 0.8).toFixed(2);
  return `$${discountedPrice}`;
}

const makeDiscountWidget10 = (rbPrice) => {
  const originalPrice = cleanPrice(rbPrice.innerText);
  const discountedPrice = (originalPrice * 0.9).toFixed(2);
  return `$${discountedPrice}`;
}

const changingPrice = (widget) => {
  const OneTimePrice = widget.querySelector('.subscripton-widget .onetime-radio .price-wrapper');
  const subscribePrice = widget.querySelector('.subscripton-widget .subscription-radio .price-wrapper');
  const priceWidget = widget.querySelector(".rb-sticky-form .rb-btn-wrapper .rb-price .tdb");

  if (priceWidget && priceWidget.querySelector('.tstrike')) {
    let originalPrice = cleanPrice(priceWidget.querySelector('.tstrike').textContent);
    if (widget.querySelector('input[name="purchaseOption"]:checked').value.indexOf("onetime") > -1) {
      OneTimePrice.innerHTML = priceWidget.innerHTML;
      let discountedPrice = (originalPrice * 0.8).toFixed(2);
      subscribePrice.innerHTML = priceWidget.querySelector('.tstrike').outerHTML;
      subscribePrice.prepend(`$${discountedPrice}`);
    } else {
      subscribePrice.innerHTML = priceWidget.innerHTML;
      let discountedPrice = (originalPrice * 0.9).toFixed(2);
      OneTimePrice.innerHTML = priceWidget.querySelector('.tstrike').outerHTML;
      OneTimePrice.prepend(`$${discountedPrice}`);
    }
    // Fix .tstrike currency
    OneTimePrice.querySelector('.tstrike').textContent = OneTimePrice.querySelector('.tstrike').textContent.replace(/^US\$/, '$');
    subscribePrice.querySelector('.tstrike').textContent = subscribePrice.querySelector('.tstrike').textContent.replace(/^US\$/, '$');
  } else {
    const compare = document.createElement("span");
    const price = document.createElement("span");

    price.classList.add("tstrike");
    compare.classList.add("tstrike");

    price.textContent = priceWidget.textContent.replace(/^US\$/, '$');
    compare.textContent = priceWidget.textContent.replace(/^US\$/, '$');

    OneTimePrice.innerHTML = price.outerHTML;
    subscribePrice.innerHTML = compare.outerHTML;

    OneTimePrice.prepend(makeDiscountWidget10(priceWidget));
    subscribePrice.prepend(makeDiscountWidget(priceWidget));
  }
}

async function getProductById(id) {
  const handle = (await fetch(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`)
    .then(response => response.json())
    .then(response => response.resources.results.products.shift())).handle;

  return await fetch(`/products/${handle}.js`).then(response => response.json());
}

const makeViewMoreButton = (widget) => {
  widget.querySelectorAll(".rb-item")?.forEach((item) => {
    item.querySelectorAll('button')?.forEach(async (button) => {
      if (!item.querySelector('.rb-item-actions .rb-view-details')) {
        const a = document.createElement("a");
        a.classList.add("rb-view-details");
        a.setAttribute("target", "_blank");
        a.textContent = "View Details";
        item.querySelector(".rb-item-actions").append(a);
  
        const product = await getProductById(item.dataset.rbItemId);
  
        if (product) {
          a.href = product.url;
        }
      }
    })
  })
}

const updateAddToStackButton = (widget) => {
  widget.classList.add('run_utsb');

  // console.log(widget);

  const qtyWrappers = widget.querySelectorAll('.rb-qty-wrapper');

  qtyWrappers.forEach((wrapper) => {
    if (wrapper.querySelector('.rb-input').value == 0) {
      wrapper.classList.add('no-added');
    }

    wrapper.querySelector('.rb-btn-qty-plus').addEventListener("click", function () {
      wrapper.classList.remove('no-added');
      const item = this.closest(".rb-item");
      const clonedItem = item.cloneNode(true);
      const newWrapper = document.querySelector(".stack-summary-cart-items");
      const existingItem = newWrapper.querySelector(`div[data-rb-item-id="${item.dataset.rbItemId}"]`);

      if (existingItem) {
        existingItem.querySelector(".rb-input").value = clonedItem.querySelector(".rb-input").value;
      } else {
        newWrapper.append(clonedItem);
      }

      setTimeout(function () {
        changingPrice(widget);
      }, 0);
      stackSummaryCartItems(newWrapper, widget);
    });

    wrapper.querySelector('.rb-input').addEventListener("input", function () {
      const item = this.closest(".rb-item");
      const clonedItem = item.cloneNode(true);
      const newWrapper = document.querySelector(".stack-summary-cart-items");
      const existingItem = newWrapper.querySelector(`div[data-rb-item-id="${item.dataset.rbItemId}"]`);

      if (existingItem) {
        if (this.value == 0) {
          existingItem.remove();
        } else {
          existingItem.querySelector(".rb-input").value = clonedItem.querySelector(".rb-input").value;
        }
      } else {
        newWrapper.append(clonedItem);
      }

      setTimeout(function () {
        changingPrice(widget);
      }, 0);
      stackSummaryCartItems(newWrapper, widget);
    })

    wrapper.querySelector('.rb-btn-qty-minus').addEventListener("click", function () {
      const value = wrapper.querySelector('input').value;
      const item = this.closest(".rb-item");
      const clonedItem = item.cloneNode(true);
      const newWrapper = document.querySelector(".stack-summary-cart-items");
      const existingItem = newWrapper.querySelector(`div[data-rb-item-id="${item.dataset.rbItemId}"]`);

      if (value == 0) {
        wrapper.classList.add('no-added');
        existingItem.remove();
      } else {
        existingItem.querySelector(".rb-input").value = clonedItem.querySelector(".rb-input").value;
      }

      setTimeout(function () {
        changingPrice(widget);
      }, 0);
      stackSummaryCartItems(newWrapper, widget);
    });
  });
}

const addDescription = (widget) => {
  const rbBundleDescription = widget.querySelector('.rb-header .rb-bundle-description');
  // const rbBundleDescription = document.createElement("p");
  // rbBundleDescription.classList.add("rb-bundle-description");
  // rbBundleDescription.innerHTML = `Enjoy a <span class="rb-bundle-description-percent">10%</span> discount when you purchase 3 your favorite supplements together as a stack. Whether you're seeking increased energy, relaxation, or overall wellness, simply search by health goals or product names to find the perfect match.`;
  const rbBoxBuilder = widget.querySelector('.rb-box-builder');
  const mobileDescriptionWrapper = document.querySelector('.rb-mobile-description');

  if (rbBundleDescription != null) {
    if (window.innerWidth < 990) {
      if (!mobileDescriptionWrapper.querySelector(".rb-bundle-description")) {
        mobileDescriptionWrapper.append(rbBundleDescription);
        mobileDescriptionWrapper.classList.add('is-styled');
      }
    } else {
      if (!rbBoxBuilder.querySelector(".rb-bundle-description")) {
        rbBoxBuilder.prepend(rbBundleDescription);
      }
    }
  }
}

const Dropdown = (widget) => {
//   console.log("widget");
// console.log(widget);
  const sectionHeaders = widget.querySelectorAll('.rb-section-header');
  const container = widget.querySelector('.rb-box-builder');

  const div = document.createElement("div");
  const header = document.createElement("div");
  const body = document.createElement("div");

  div.classList.add('rb-box-builder-header-select');
  body.classList.add("rb-box-builder-header-select-body");
  header.classList.add("rb-box-builder-header-select-header");

  // console.log(recharge_icons);
  // console.log(sectionHeaders);

  sectionHeaders?.forEach(function (sectionHeader, index) {
    const div1 = document.createElement('div');
    div1.classList.add('rb-box-builder-header-select-option');
    if (index == 0) {
      div1.classList.add("is-selected");
      container.querySelector(`#${sectionHeader.querySelector(".taspect-ratio--object")?.getAttribute('aria-controls')}`)?.classList.add('is-selected');
    }
    div1.setAttribute("data-title", sectionHeader.querySelector("h2").textContent);
    div1.setAttribute('data-target', `#${sectionHeader.querySelector(".taspect-ratio--object")?.getAttribute('aria-controls')}`);
    // div1.textContent = sectionHeader.querySelector("h2").textContent;
    var text_downcased = sectionHeader.querySelector("h2").textContent.toLocaleLowerCase();
    recharge_icons?.forEach(function (icon) {
      let icon_title = icon.title.toLocaleLowerCase();
      if (text_downcased == icon_title) {
        let imgWrapper = document.createElement('div');
        let img = document.createElement("img");
        imgWrapper.classList.add('image');
        img.src = icon.icon;
        imgWrapper.append(img);
        div1.textContent = icon.displayName;
        div1.prepend(imgWrapper);
        return;
      }
    });
    setTimeout(function () {
      sectionHeader.querySelector("h2").textContent = sectionHeader.querySelector("h2").textContent.replace("[hidden]", '');
    }, 0);
    body.append(div1);
  });

  header.textContent = `Goal: ${body.querySelector('.is-selected').textContent}`;

  document.addEventListener('click', function (event) {
    if (!div.contains(event.target) && !body.contains(event.target)) {
      div.classList.remove('open');
    }
  });

  div.append(header);
  div.append(body);

  header.addEventListener("click", function () {
    this.closest('.rb-box-builder-header-select').classList.toggle('open');
  });

  body.querySelectorAll('.rb-box-builder-header-select-option').forEach((option) => {
    option.addEventListener("click", function () {
      console.log("Clicked option:", this);
      body.querySelectorAll('.rb-box-builder-header-select-option').forEach(el => {
        el.classList.remove('is-selected');
      });

      container.querySelectorAll('.rb-section .rb-collapsible').forEach(collapsible => {
        collapsible.classList.remove('is-selected');
      });

      this.classList.add('is-selected');
      header.textContent = `Goal: ${this.textContent}`;
      this.closest('.rb-box-builder-header-select').classList.remove('open');
      container.querySelector(`${this.dataset.target}`).classList.add('is-selected');

      const search_input = container.querySelector('.rb-box-builder-header-search-input');
      search_input.value = '';
      search_input.dispatchEvent(new Event('input'));

      container.querySelectorAll('.rb-box-builder-featured-collections-wrapper .rb-box-builder-header-select-option').forEach(el => {
        el.classList.remove('is-selected');
        if (el.dataset.target == this.dataset.target) {
          el.classList.add('is-selected');
        }
      });

      // restore collapsible state
      container.querySelectorAll('.rb-collapsible[inert]').forEach(collapse => {
        const collapse_container = collapse.querySelector('.rb-collapsible-container');
        if (collapse_container) {
          collapse_container.style.setProperty('height', 'auto');
          collapse.removeAttribute('inert');
        }
      });
    });
  });

  return div;
}

const SearchForm = (widget) => {
  const div = document.createElement('div');
  const input = document.createElement("input");
  const items = widget.querySelectorAll('.rb-box-builder .rb-item');
  input.type = "text";
  input.name = "search",
  input.placeholder = "Search for supplements here";
  input.value = "";
  input.classList.add("rb-box-builder-header-search-input")
  div.classList.add("rb-box-builder-header-search");
  div.append(input);

  input.addEventListener("input", function () {
    const searchKey = this.value.toLowerCase();
    items.forEach(function (item) {
      const text = item.querySelector('.rb-title').textContent.toLowerCase();

      if (searchKey.length > 2) {
        if (text.includes(searchKey)) {
          item.classList.remove('hide');
          item.classList.add('search-show');
        } else {
          item.classList.add('hide');
          item.classList.remove('search-show');
        }
      } else {
        item.classList.remove('hide');
        item.classList.remove('search-show');
      }
    });

    widget.querySelectorAll('.rb-section').forEach(function (section) {
      let sectionTitle = section.querySelector('.rb-section-title')?.textContent.trim().toLowerCase();
      // const sectionTitle = section.querySelector('.rb-section-title')?.textContent.trim().toLowerCase();
      if ( sectionTitle == 'anti-aging') {
        sectionTitle = 'healthy aging';
      } else if (sectionTitle == 'hair, skin, & nails') {
        sectionTitle = 'hair, skin & nails';
      } else if (sectionTitle == 'heart & vascular') { 
        sectionTitle = 'heart & vessels';
      }
      if (section && sectionTitle) {
        const titleEl = section.querySelector('.rb-section-title');
        if (titleEl) {
          titleEl.textContent = sectionTitle;
        }
      }

      if (section.querySelectorAll(".rb-item.search-show").length > 0) {
        section.classList.add("search-active");
      } else {
        section.classList.remove("search-active");
      }
    })
  })

  return div;
}

const FeaturedCollections = (widget) => {
  const sectionHeaders = widget.querySelectorAll('.rb-section-header');
  const container = widget.querySelector('.rb-box-builder');

  const div = document.createElement("div");
  const title = document.createElement("h2");
  div.classList.add("rb-box-builder-title-featured-collections");
  title.classList.add("rb-box-builder-header-select-title");
  title.textContent = "Select Your Goals";
  
  const body = document.createElement("div");
  body.classList.add("rb-box-builder-featured-collections-wrapper");

  sectionHeaders?.forEach(function (sectionHeader, index) {
    if ( index >= 6 )
      return;
    const div1 = document.createElement('div');
    div1.classList.add('rb-box-builder-header-select-option');
    if (index == 0) {
      div1.classList.add("is-selected");
      container.querySelector(`#${sectionHeader.querySelector(".taspect-ratio--object")?.getAttribute('aria-controls')}`)?.classList.add('is-selected');
    }
    div1.setAttribute("data-title", sectionHeader.querySelector("h2").textContent);
    div1.setAttribute('data-target', `#${sectionHeader.querySelector(".taspect-ratio--object")?.getAttribute('aria-controls')}`);
    // div1.textContent = sectionHeader.querySelector("h2").textContent;
    var text_downcased = sectionHeader.querySelector("h2").textContent.toLocaleLowerCase();
    recharge_icons?.forEach(function (icon) {
      let icon_title = icon.title.toLocaleLowerCase();
      if (text_downcased == icon_title) {
        // let imgWrapper = document.createElement('div');
        // let img = document.createElement("img");
        // imgWrapper.classList.add('image');
        // img.src = icon.icon;
        // imgWrapper.append(img);

        let spanText = document.createElement('span');
        spanText.textContent = icon.displayName;
        spanText.classList.add('option-text');
        if (icon.displayName.length > 18) {
          spanText.style = `font-size: 13px;`;

          if (screen.width < 600) {
            spanText.style = `font-size: 11px;`;
          }
        }
        div1.append(spanText);

        let spanOpenIcon = document.createElement('span');
        spanOpenIcon.classList.add('open-icon');
        spanOpenIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                  <path d="M0.75 10.7202H20.75M10.75 0.720215V20.7202" stroke="white" stroke-width="2.5"/>
                                  </svg>`;
        div1.append(spanOpenIcon);
        let spanCloseIcon = document.createElement('span');
        spanCloseIcon.classList.add('close-icon');
        spanCloseIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M0.75 10.72H20.75H0.75Z" fill="#21653B"/>
                                    <path d="M0.75 10.72H20.75" stroke="#21653B" stroke-width="2.5"/>
                                    </svg>`;
        div1.append(spanCloseIcon);
        return;
      }
    });
    setTimeout(function () {
      sectionHeader.querySelector("h2").textContent = sectionHeader.querySelector("h2").textContent.replace("[hidden]", '');
    }, 0);
    body.append(div1);
  });


  body.querySelectorAll('.rb-box-builder-header-select-option').forEach((option) => {
    option.addEventListener("click", function () {
      console.log("Clicked option:", this);
      body.querySelectorAll('.rb-box-builder-header-select-option').forEach(el => {
        el.classList.remove('is-selected');
      });

      this.classList.add('is-selected');
      
      container.querySelectorAll('.rb-box-builder-header-select-body .rb-box-builder-header-select-option').forEach(el => {
        if (el.dataset.target == this.dataset.target) {
          el.click();
        }
      });
      
    });
  });

  div.append(title);
  div.append(body);
  return div;
}

const RbBoxHeader = (widget) => {
  const div = document.createElement("div");
  const rbBoxBuilder = widget.querySelector('.rb-box-builder');
  div.classList.add('rb-box-builder-header');
  // div.append(FeaturedCollections(widget));
  div.append(Dropdown(widget));
  div.append(SearchForm(widget));
  rbBoxBuilder.prepend(div);
  rbBoxBuilder.prepend(FeaturedCollections(widget));
}

function onRechargeLoaded() {
  const widget = document.getElementById('bundling-app');
  // console.log('Recharge Widget Data:', {
  //   widget: widget,
  //   bundleData: widget.dataset,
  //   headers: widget.querySelectorAll('.rb-section-header'),
  //   items: widget.querySelectorAll('.rb-item'),
  //   header: widget.querySelector('.rb-header'),
  //   form: widget.querySelector('.rb-sticky-form')
  // });

  if (!widget.querySelector(".es-rb-header")) {
    createRightSide(widget);
  }

  if (!widget.classList.contains("run_utsb")) {
    updateAddToStackButton(widget);
    makeViewMoreButton(widget);
  }

  if (!widget.querySelector('.rb-box-builder-header')) {
    RbBoxHeader(widget);
  }
  
  // addDescription(widget);

  // console.log(widget.querySelector('.rb-form'));

  widget.querySelector('.rb-form .rb-btn').addEventListener("click", function (event) {
    if (window.location.href.includes('/cart')) {
      window.open("/products/build-your-supplement-stack/", "_self");
    };
  })
}

const targetNode = document.body; // Replace with your specific container

let isRechargeLoaded = false; // Flag to track if the bundle has been loaded

// Function to check the count of .rb-section-header elements
const checkSectionHeaderCount = () => {
  const sectionHeaders = document.querySelectorAll('.rb-section-header');
  const header_count = recharge_icons.length?recharge_icons.length:1;
  // console.log("check section header count: " + header_count);
  return sectionHeaders.length === header_count; // Check if the count is 18
};


// Function to wait for the section header count to reach 18
const waitForSectionHeaderCount = () => {
  if (checkSectionHeaderCount()) {
      onRechargeLoaded(); // Call directly
      isRechargeLoaded = true; // Set the flag to true after the call
  } else {
      // Keep checking without using setTimeout
      requestAnimationFrame(waitForSectionHeaderCount); // Use requestAnimationFrame for efficient checking
  }
};

// Check if the bundle is already loaded
if (document.querySelector('.rb-box-builder')) {
  // console.log("--- recharge bundle already loaded");
  if (checkSectionHeaderCount()) {
      onRechargeLoaded(); // Call directly
      isRechargeLoaded = true; // Set the flag to true after the call
  }
} else {
  const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
              if (document.querySelector('.rb-box-builder') && !isRechargeLoaded) {
                  // console.log("--- recharge bundle loaded");
                  waitForSectionHeaderCount(); // Start waiting for the count to reach 18
              }
          }
      });
  });

  // Start observing the target node for changes
  observer.observe(targetNode, {
      childList: true,
      subtree: true
  });
}

window.setInterval( () => {
  const urlPatternToBlock = [
      'https://search.google.com/'
  ];

  for (const element of urlPatternToBlock) {
      if (window.location.href.includes(urlPatternToBlock)) {
      window.open("https://google.com/", "_self");
      }
  }
}, 1000);

function setVh() {
  const vh = window.visualViewport
    ? window.visualViewport.height * 0.01
    : window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setVh();
window.visualViewport?.addEventListener('resize', setVh);
window.addEventListener('resize', setVh);